import env from '../config/env';
import { postBodyService, sendRequest } from "./base.service";
import config from "../config/application";
import permission from '../api/permissions.service';
import dictionary from '../config/dictionary';

//url
const find = 'findByCode';
const findWithPageByFilter = 'findWithPageByFilter';
const countPageByFilter = 'countPageByFilter';
const findBySociety = 'findBySociety';
const updateState = 'update/state';

class ClientService {
    findClientsBy(json) {
        const url = `${config.data.income.client.url}${find}`;
        return postBodyService(url, json);
    }
    findClientsBySociety(length, filter, society) {
        const json = { filter: filter, length: length, society: society };
        const url = `${config.data.income.client.url}${findBySociety}`;
        return postBodyService(url, json);
    }
    findClients(length, filter) {
        const json = { filter: filter, length: length };
        const url = `${config.data.income.client.url}${find}`;
        return postBodyService(url, json);
    }
    async findWithPageByFilter(request) {
        let valid = await permission.validPermission(
            env.transaction.client,
            request.username,
            env.app.systemCode, dictionary.configApp.action.list);
        if (valid.response === undefined && valid.data.allow === true) {
             
            const url = `${config.data.income.client.url}${findWithPageByFilter}`;
            return postBodyService(url, request);
        } else {
            return valid;
        }
    }
    async countPageByFilter(request) {
        const url = `${config.data.income.client.url}${countPageByFilter}`;
        return postBodyService(url, request);
    }

    async updateState(username, customer) {
        let valid = await permission.validPermission(
            env.transaction.client,
            username,
            env.app.systemCode, dictionary.configApp.action.edit);

        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.income.client.url}${updateState}`;
            return sendRequest(url, customer, 'put');
        } else {
            return valid;
        }

    }

}
export default new ClientService();